import { render } from "./LoginHeader.vue?vue&type=template&id=350f6410"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"

import "./LoginHeader.vue?vue&type=style&index=0&id=350f6410&lang=scss"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__